export class Filter {
  constructor(
    public startDate: string,
    public endDate: string,
    public searchedText: string
  ) {}
}
